import * as React from "react";
import { forwardRef } from "react";
const SvgAdComputer = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "#0078D4", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 12, x: 4, y: 4, rx: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M8 20h8m-4-4v4M8 8h1m-1 3h1m2-3h1m-1 3h1m2-3h1m-1 3h1" }));
const ForwardRef = forwardRef(SvgAdComputer);
export default ForwardRef;
